import { transition, container } from "assets/jss/material-dashboard-react.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: "100%"
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "0",
    padding: "0px 15px",
    minHeight: "calc(100vh - 123px)"
  },
  container,
  header: {
    display: "flex"
  },
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
